module.exports = __webpack_public_path__ + "static/result_quokkarocks_wishmas-7db7e83612493d2cef7525d3ee4f2e50.jpg";